import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ProfileSearchAdvancedOptionsComponent } from './profile-search-advanced-options/profile-search-advanced-options.component';
import { UtilService, DialogService, NotificationService, TranslationService, DatagridService } from '../../shared/index';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PagedResult } from '../../shared/model/paged-result.model';
import { DataView as PrimeDataList } from 'primeng/dataview';
import { AsyncState } from '../../shared/model/index';
import { LocalStorageService } from '../../shared/storage/local-storage.service';
import { AuthService } from '../../shared/auth/auth.service';
import { AuthUserInfo } from '../../shared/auth/auth-user-info.model';
//import moment from 'moment-es6';

import { ProfileSearchService } from './profile-search.service';
import { ProfileAdvancedSearchParams } from './profile-advanced-search-params.model';
import { ProfileSearchResult } from './profile-search-result.model';
import { ProfileSearchComponentModel } from './profile-search-component.model';
import { ProfileMin } from '../shared/profile-min.model';

const _profileResultModelKey: string = 'profileResultModel';

@Component({
  selector: 'wl-profile-search-modal',
  templateUrl: 'profile-search-modal.component.html',
  providers: [ProfileSearchService],
  standalone: false,
})
export class ProfileSearchModalComponent implements OnInit {
  @ViewChild('profilesDataGrid', { static: false }) public _profilesDataGrid: PrimeDataList;
  @ViewChild(ProfileSearchAdvancedOptionsComponent) private _advancedSearch: ProfileSearchAdvancedOptionsComponent;
  @Input() advancedSearchVisible: boolean = false;

  //results grid column config properties
  @Input() showProfileId: boolean = true;
  @Input() showReportName: boolean = true;
  @Input() showRelatedProfile: boolean = true;
  @Input() showMembershipLevel: boolean = true;
  @Input() showEmail: boolean = true;
  @Input() showEmailType: boolean = false;
  @Input() alwaysShowAdvancedSearch: boolean = false;

  @Output() close: EventEmitter<Array<ProfileMin>> = new EventEmitter();

  // indicate whether or not to load data from the api
  public _fullLazyLoad: boolean;
  public _initComplete: boolean;
  public profileSelectorSearched: boolean = false;

  public isSearching: boolean;
  public selectedAction: number = 0;
  public useDuesBillingDate: boolean;
  public hasEventBenefits: boolean;
  public loading: AsyncState;
  public results: ProfileSearchResult;
  public profileSearchComponentModel: ProfileSearchComponentModel;
  public selectedResults: Array<ProfileMin>;
  public showSearchModal = false;

  public get columnCount() {
    return (
      1 +
      +this.showProfileId +
      +this.showReportName +
      +this.showRelatedProfile +
      +this.showMembershipLevel +
      +this.showEmail +
      +this.showEmailType
    );
  }

  public constructor(
    private _utilService: UtilService,
    private _notifyService: NotificationService,
    private _translationService: TranslationService,
    private _dialogService: DialogService,
    private _navigationService: NavigationService,
    private _dataGridService: DatagridService,
    private _authService: AuthService,
    private _localStorageService: LocalStorageService,
    private _profileSearchService: ProfileSearchService
  ) {
    this.loading = new AsyncState();
    this._fullLazyLoad = false;
    this.useDuesBillingDate = false;
    this.selectedAction = 0;
    this._initComplete = false;
    this.hasEventBenefits = true;
    this.profileSearchComponentModel = new ProfileSearchComponentModel();
    this.selectedResults = new Array<ProfileMin>();
  }

  ngOnInit() {
    let pageEvent = { first: 0, rows: 10 };
    let componentModelRaw: string = ''; //this._localStorageService.getString(_profileResultModelKey + window["wlVersion"]);
    if (componentModelRaw) {
      let tempComponentModel: ProfileSearchComponentModel = JSON.parse(componentModelRaw);
      let promise = this._authService.getUserInfo().then((x) => {
        if (tempComponentModel.userNum == x.wli_usernum && tempComponentModel.clientId == x.client_id) {
          this.profileSearchComponentModel = tempComponentModel;
        } else {
          this.profileSearchComponentModel.userNum = x.wli_usernum;
          this.profileSearchComponentModel.clientId = x.client_id;
          this._fullLazyLoad = true;
        }
        this._initComplete = true;
        this._profilesDataGrid?.paginate(pageEvent);
      });
    } else {
      this._initComplete = true;
      this._fullLazyLoad = true;
      this._profilesDataGrid?.paginate(pageEvent);
    }

    if (this.advancedSearchVisible == true) {
      this.profileSearchComponentModel.showAdvancedSearch = true;
    }
  }

  public showModal = (): void => {
    this.showSearchModal = true;
  };

  public handleShowAdvancedSearch = (): void => {
    this.profileSearchComponentModel.showAdvancedSearch = true;
  };

  public handleHideAdvancedSearch = (): void => {
    this.profileSearchComponentModel.showAdvancedSearch = false;
  };

  public handleEditClick = (profileId: number): void => {
    this._navigationService.navigateToProfileBenefitsManagement(profileId);
  };

  public onSelectAllChange = (selectAll: boolean): void => {
    //reset the tracking array
    this.profileSearchComponentModel.selectedProfiles = new Array<number>();
    this.profileSearchComponentModel.selectAllProfiles = selectAll;
    this.selectedResults = new Array<ProfileMin>();

    for (let item of this.profileSearchComponentModel.profiles.Result) {
      item.Selected = selectAll;
    }
    // save the model for later
    //this._localStorageService.setString(_profileResultModelKey + window["wlVersion"], JSON.stringify(this.profileSearchComponentModel));
  };

  public onProfileSelectedChange = (item: any): void => {
    // track it if it doesn't match the selectAllProfiles variable
    if (item.Selected != this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.selectedProfiles.push(item.ProfileId);
      this.selectedResults = [...this.selectedResults, item];
    } else {
      let ind = this.profileSearchComponentModel.selectedProfiles.findIndex((id) => id == item.ProfileId);
      if (ind != null) this.profileSearchComponentModel.selectedProfiles.splice(ind, 1);

      ind = this.selectedResults.findIndex((profile) => profile.ProfileId == item.ProfileId);
      if (ind != null) this.selectedResults.splice(ind, 1);
    }
    // save the model for later
    //this._localStorageService.setString(_profileResultModelKey + window["wlVersion"], JSON.stringify(this.profileSearchComponentModel));
  };

  public searchProfiles = (): void => {
    this.selectedResults = new Array<ProfileMin>();
    this.profileSelectorSearched = true;
    (<any>this._profilesDataGrid).first = 0;
    this.profileSearchComponentModel.searchParams.PageNumber = 1;
    //reset the tracking array
    this.profileSearchComponentModel.selectedProfiles = new Array<number>();
    this.profileSearchComponentModel.selectAllProfiles = false;
    this.lazyLoadProfiles({ first: 0, rows: 10 });
  };

  public clearProfiles = (): void => {
    setTimeout(() => (this.profileSearchComponentModel.searchParams = new ProfileAdvancedSearchParams()));
    this.profileSearchComponentModel.searchParams.OrderBy = 'ReportName';
    //reset the tracking array
    this.profileSearchComponentModel.selectAllProfiles = false;
    this.profileSearchComponentModel.searchParams.IgnoreProfiles = [];
    this.profileSearchComponentModel.searchParams.PermitProfiles = [];
    this.profileSearchComponentModel.selectedProfiles = new Array<number>();
    this.profileSearchComponentModel.profiles = new ProfileSearchResult();
    this._localStorageService.removeItem(_profileResultModelKey + window['wlVersion']);
  };

  public lazyLoadProfiles = ($event: any): void => {
    // this is a hack. the page numbers don't work unless lazy load is on and setting the page numbers from the cache on init triggers this method.
    if (!this._initComplete) {
      return;
    }

    if (!this.profileSelectorSearched) {
      this.profileSearchComponentModel.profiles = new ProfileSearchResult();
      return;
    }

    this._dataGridService.mapDatagridPagingToPagedSearch($event, this.profileSearchComponentModel.searchParams);
    if ($event) {
      this.profileSearchComponentModel.searchParams.PageNumber = $event.first / Math.max(1, $event.rows) + 1;
      this.profileSearchComponentModel.searchParams.PageSize = 10;
    }
    if (!this._fullLazyLoad) {
      // we got the data from local storage. don't load data from the api.
      this._fullLazyLoad = true;
      return;
    }

    this.loading.busy = true;
    this.loading.success = false;
    this.isSearching = true;

    this._profileSearchService.advancedSearch(this.profileSearchComponentModel.searchParams).then(
      (data: PagedResult) => {
        this.profileSearchComponentModel.profiles = data;
        this.isSearching = false;
        this._advancedSearch.isSearching = false;
        this.loading.busy = false;
        this.loading.success = true;
        //this._localStorageService.setString(_profileResultModelKey + window["wlVersion"], JSON.stringify(this.profileSearchComponentModel));
        this.profileSearchComponentModel.profiles.Result.forEach(
          (x) =>
            (x.Selected =
              this.profileSearchComponentModel.selectAllProfiles !==
              this.profileSearchComponentModel.selectedProfiles.indexOf(x.ProfileId) > -1)
        );
      },
      () => {
        this.isSearching = false;
        this._advancedSearch.isSearching = false;
        this.loading.busy = false;
        this.loading.success = false;
      }
    );
  };

  public selectProfiles = (): void => {
    if (this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.searchParams.PageSize = 999999;
      this._profileSearchService.advancedSearch(this.profileSearchComponentModel.searchParams).then(
        (data: PagedResult) => {
          this.profileSearchComponentModel.profiles = data;
          this.isSearching = false;
          this._advancedSearch.isSearching = false;
          this.loading.busy = false;
          this.loading.success = true;
          //this._localStorageService.setString(_profileResultModelKey + window["wlVersion"], JSON.stringify(this.profileSearchComponentModel));
          this.profileSearchComponentModel.profiles.Result.forEach(
            (x) =>
              (x.Selected =
                this.profileSearchComponentModel.selectAllProfiles !==
                this.profileSearchComponentModel.selectedProfiles.indexOf(x.ProfileId) > -1)
          );
          this.selectedResults = this.profileSearchComponentModel.profiles.Result;

          this.close.emit(this.selectedResults);
          this.showSearchModal = false;
        },
        () => {
          this.isSearching = false;
          this._advancedSearch.isSearching = false;
          this.loading.busy = false;
          this.loading.success = false;
        }
      );
    } else {
      this.close.emit(this.selectedResults);
      this.showSearchModal = false;
    }
  };
}
